import React, { useEffect } from "react";
import PropTypes from "prop-types";

import "./taboola.m.css";

const TaboolaAd = ({ container, placement }) => {
  useEffect(() => {
    loadScript();
  }, []);

  const loadScript = () => {
    window._taboola = window._taboola || [];

    _taboola.push({ // eslint-disable-line
      mode: "alternating-thumbnails-a",
      container: container,
      placement: placement,
      target_type: "mix"
    });
  };

  return (
    <div styleName="ad-wrapper">
      <div id={container} />
    </div>
  );
};

TaboolaAd.propTypes = {
  container: PropTypes.string,
  placement: PropTypes.string
};

export default TaboolaAd;
